import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckCircle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckCircle2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.4482 14.5723L8.28125 12.3945L7.75293 11.8623L6.68945 12.9199L10.6768 16.9277L16.29 8.54395L15.0439 7.70996L10.4482 14.5723Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckCircle2;
